import { RenewComponent } from './renew/renew.component';
import { ExtendComponent } from './extend/extend.component';
import { MineComponent } from './mine/mine.component';
import { MineChildRoutes } from './mine/mine.routing';
import { NewComponent } from './new/new.component';
import { NewChildRoutes } from './new/new.routing';
import { ExtendChildRoutes } from './extend/extend.routing';
import { ApproveChildRoutes } from './approve/approve.routing';
import { ApproveComponent } from './approve/approve.component';
import { ShowComponent } from './show/show.component';
import { AuthGuard } from '@/auth/guard/auth.guard';
import { RouteWithGuardData } from '@/auth/interface/auth.interface';
import { getDefinitionByPath } from '@/auth/routes/auth.routes';
import { renewChildRoutes } from './renew/renew.routing';
import { ShowDeletedComponent } from './show-deleted/show-deleted.component';
import { ShowDeletedChildRoutes } from './show-deleted/show-deleted.routing';

export const LicenseChildRoutes: RouteWithGuardData[] = [
  {
    path: 'new',
    component: NewComponent,
    children: NewChildRoutes,

    canActivate: [AuthGuard],
    data: getDefinitionByPath('/license/new'),
  },
  {
    path: 'renew',
    component: RenewComponent,
    children: renewChildRoutes,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/license/renew'),
  },
  {
    path: 'approve',
    component: ApproveComponent,
    children: ApproveChildRoutes,

    canActivate: [AuthGuard],
    data: getDefinitionByPath('/license/approve'),
  },
  {
    path: 'mine',
    component: MineComponent,
    children: MineChildRoutes,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/license/mine'),
  },
  {
    path: 'extend',
    component: ExtendComponent,
    children: ExtendChildRoutes,

    canActivate: [AuthGuard],
    data: getDefinitionByPath('/license/extend'),
  },
  {
    path: 'show-deleted',
    component: ShowDeletedComponent,
    children: ShowDeletedChildRoutes,
    canActivate: [AuthGuard],
    data: getDefinitionByPath('/license/show-deleted'),
  },
  {
    path: 'show/:ofuscatedData',
    component: ShowComponent,
  },
  {
    path: '**',
    pathMatch: 'full',
    redirectTo: '/dashboard',
  },
];
